import { render, staticRenderFns } from "./helloworld.vue?vue&type=template&id=0c9d7ddb&"
import script from "./helloworld.vue?vue&type=script&lang=js&"
export * from "./helloworld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9d7ddb')) {
      api.createRecord('0c9d7ddb', component.options)
    } else {
      api.reload('0c9d7ddb', component.options)
    }
    module.hot.accept("./helloworld.vue?vue&type=template&id=0c9d7ddb&", function () {
      api.rerender('0c9d7ddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/helloworld.vue"
export default component.exports